import { InfoFilledIcon } from '@calizahq/react-components-v2'
import { formatMoney } from '@sales-app/views/PotentialBooking/PotentialBooking/ActivitySection/RecommendedHomes/MapView/MapPopup/MapPopup.util'
import { formatInTimeZone } from 'date-fns-tz'
import React from 'react'
import { Link } from 'react-router-dom'

import { Tag } from '@/components'
import { HomeQualityCheckStatus } from '@/types/HomeQualityCheck'
import { ReservationsListRow } from '@/types/Reservation'
import { getReservationFXTag, getReservationLexitTag } from '@/views/Reservation/Reservations/Reservations.data'

export const MemberReservationListColumns = [
  {
    Header: 'Reservation',
    accessor: 'name',
    width: 70,
    Cell: function _Cell({ row }: { row: { original: ReservationsListRow } }) {
      const { home } = row.original

      return (
        <div className="flex items-center justify-center" title="View Home">
          <div className="flex flex-col font-medium">
            <Link to={`/homes/${home.id}`}>
              <h3 className="font-bold hover:underline">{home.searchDocument}</h3>
            </Link>
          </div>
        </div>
      )
    },
  },
  {
    Header: 'Status',
    accessor: 'home.homeQualityStatus',
    width: 30,
    Cell: ({ value }: any) => {
      return (
        <Tag className="ml-2" variant={value === HomeQualityCheckStatus.READY ? 'success' : 'error'}>
          {value}
        </Tag>
      )
    },
  },
  {
    Header: 'Rate',
    width: 30,
    Cell: function _Cell({ row }: { row: { original: ReservationsListRow } }) {
      const { monthlyRent, nightlyRate } = row.original

      const rate = monthlyRent ? monthlyRent : nightlyRate ? nightlyRate : 0

      return (
        <div className="flex w-fit-content flex-wrap items-baseline">
          <p className="font-bold text-black md:font-medium">{formatMoney(rate, false)}</p>
        </div>
      )
    },
  },
  {
    Header: 'Move In Date',
    accessor: 'moveInDate',
    width: 30,
    Cell: function _Cell({ value = '' }: { value: string }) {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      try {
        const time = formatInTimeZone(value, timezone, 'MMM d, yyyy')
        return time
      } catch (e) {
        return 'Invalid  Date'
      }
    },
  },
  {
    Header: 'Move Out Date',
    accessor: 'moveOutDate',
    width: 30,
    Cell: function _Cell({ value = '' }: { value: string }) {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      try {
        const time = formatInTimeZone(value, timezone, 'MMM d, yyyy')
        return time
      } catch (e) {
        return 'Pending'
      }
    },
  },
  {
    Header: 'Tags',
    width: 50,
    Cell: ({ row }: { row: { original: ReservationsListRow } }) => {
      const value = row.original || {}

      const fxStatus = getReservationFXTag(value)
      const lexitStatus = getReservationLexitTag(value)
      const isCancelled = !!value.cancelledAt

      return (
        <div className="flex w-full items-center justify-center">
          <Tag className="p-2 py-1 text-p-xs capitalize" variant="info">
            {value.status}
          </Tag>
          {isCancelled && <Tag className="mr-1 rounded-full text-sm text-tag-red-dark tag-red-light">Cancelled</Tag>}
          {fxStatus && (
            <Tag className="ml-1 p-2 py-1 text-p-xs" variant={fxStatus.tag}>
              {fxStatus.label}
            </Tag>
          )}
          {lexitStatus && (
            <Tag className="ml-1 p-2 py-1 text-p-xs" variant={lexitStatus.tag}>
              {lexitStatus.label}
            </Tag>
          )}
        </div>
      )
    },
  },
  {
    accessor: 'id',
    width: 10,
    Cell: function _Cell({ value }: any) {
      return (
        <div className="ml-auto flex items-center justify-center" title="View Reservation">
          <Link to={`/reservations/${value}`}>
            <InfoFilledIcon className="ml-2 text-green-300" height={24} width={24} />
          </Link>
        </div>
      )
    },
  },
]
